import gql from 'graphql-tag'

export const newRoutine = gql`
  mutation newRoutine(
    $name: String!
    $frequency: String
    $dateStart: DateTime
    $type: String
    $userId: ID!
  ) {
    createRoutine(
      name: $name
      frequency: $frequency
      dateStart: $dateStart
      type: $type
      userId: $userId
    ) {
      id
    }
  }
`

export const updateRoutine = gql`
  mutation updateRoutine(
    $name: String!
    $frequency: String
    $id: ID!
    $userId: ID!
  ) {
    updateRoutine(
      name: $name
      frequency: $frequency
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const deleteRoutine = gql`
  mutation deleteRoutine($id: ID!) {
    deleteRoutine(id: $id) {
      id
    }
  }
`
export const addToRoutinesOnGroup = gql`
  mutation addToRoutinesOnGroup($routinesRoutineId: ID!, $groupsGroupId: ID!) {
    addToRoutinesOnGroup(
      routinesRoutineId: $routinesRoutineId
      groupsGroupId: $groupsGroupId
    ) {
      routinesRoutine {
        id
      }
    }
  }
`
export const addToRoutinesOnRoutine = gql`
  mutation addToRoutinesOnRoutine(
    $routines1RoutineId: ID!
    $routines2RoutineId: ID!
  ) {
    addToRoutinesOnRoutine(
      routines1RoutineId: $routines1RoutineId
      routines2RoutineId: $routines2RoutineId
    ) {
      routines1Routine {
        id
      }
    }
  }
`

export const removeFromRoutinesOnGroup = gql`
  mutation removeFromRoutinesOnGroup(
    $routinesRoutineId: ID!
    $groupsGroupId: ID!
  ) {
    removeFromRoutinesOnGroup(
      routinesRoutineId: $routinesRoutineId
      groupsGroupId: $groupsGroupId
    ) {
      routinesRoutine {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/routine.js